import { DentallyWizardService } from './dentally-wizard.service';
import { Component, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { OnInit } from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';
import { environment } from '../../../../environments/environment';
import { Observable, from } from 'rxjs';
import { AuthMsgService } from '../../../../auth/auth-msg.service';
import { OrgSettingsService } from 'src/org-settings/org-settings.service';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { map } from 'rxjs/operators';
import { AppConfigService, AppConfig } from 'src/services/app-config.service';
import { InjectHyperlinkPipe } from '../../pipes/inject-hyperlink.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IHasStepNumber } from 'src/core/interfaces/IHasStepNumber';

@Component({
  selector: 'dentallywizard',
  templateUrl: './dentallywizard.component.html',
  styleUrls: ['dentallywizard.component.scss']
})
export class DentallyWizardComponent implements OnInit, AfterViewInit {

  stepNumber: number = 0;

  constructor(private router: Router, private route: ActivatedRoute, private dentallyService: DentallyWizardService, private authMsgService: AuthMsgService, private authService: AuthService) {

  }
  ngAfterViewInit(): void {
    this.authMsgService.hideSideNav(false);
    this.authMsgService.sendMessage(true);
  }

  ngOnInit(): void {
    this.authService.getClaims$().subscribe(() => {
      this.dentallyService.getWizardState().subscribe((wizardState) => {
        if (!wizardState) {
          this.router.navigateByUrl("/home");
        } else if (this.router.url.endsWith("dentally") || this.router.url.endsWith("dentally/")) {
          this.router.navigateByUrl("/wizard/dentally/connect");
        }
      });
    });
  }

  public onRouterOutletActivate(event: IHasStepNumber) {
    this.stepNumber = event.stepNumber;
  }
}
